<template>
    <div>
        <h1 
            class="fs-4 fw-bold text-dark mb-1 lh-sm"
        >
            Política de precios frente a competidor
        </h1>
        <p
            class="text-muted small fw-medium "
        >
            Configura cómo quieres posicionar cada producto respecto al mercado.
        </p>
        <TableCompetitorConfig
            @getData="getSearch"
            @change-page="changePage"
            @change-page-size="changePageSize"
            @viewModal="viewModal"
            @filterConfigStatus="updateConfigStatus"
            @filterCompetitor="updateCompetitor"
            @filterPositioning="updatePositioning"
            :products="productList"
            :loading="loading"
            :total-count="totalProducts"
            :current-page="currentPage"
            :page-size="pageSize"
        />
        <!-- Modal -->
        <modal-form
            v-if="propHead.open"
            :propSize="propForm.size"
            :propHead="propHead"
            @closeModal="closeModal"
        >
            <template slot="form">
                <component :is="componentName" :propHead="propHead" @refrest="refrest" @closeModal="closeModal"/>
            </template>
        </modal-form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import configsRecModuleMixin from '../mixins/configsRecModuleMixin';
import TableCompetitorConfig from './TableCompetitorConfig.vue';
import ModalForm from "../../../../../components/modal.vue";
import ConfigCompetitorUpdateOne from './configCompetitorUpdateOne.vue';
import ConfigCompetitorOptions from './configCompetitorOptions.vue';
import ConfigCompetitorCreateOne from './configCompetitorCreateOne.vue';

export default {
    name: 'config-competitor',
    mixins: [configsRecModuleMixin],
    components: {
        TableCompetitorConfig,
        ModalForm,
        ConfigCompetitorUpdateOne,
        ConfigCompetitorOptions,
        ConfigCompetitorCreateOne
    },
    data() {
        return {
            propHead: {
                action: "",
                open: false,
                module: "competidor",
                text : ""
            },
            propForm: {
                size: "",
                form: "",
            },
            componentName: null,
            competitorConfigStatus: '',
            selectedCompetitor: '',
            selectedPositioning: '',
            storeModule: 'scraping',
            storeKey: 'rules',
            mutationName: 'product_scraping_rule_list',
        };
    },
    methods: {
        ...mapActions(["executeCommit"]),
        buildUrl() {
            return `/api/pricescrapingrules/list_config_competitor/?${this.buildCommonParams()}&competitor_status=${this.competitorConfigStatus}&competitor=${this.selectedCompetitor}&positioning=${this.selectedPositioning}&prop_extra_3=VIGENTE`;
        },
        viewModal(row, name, title, text) {
            this.componentName = name;
            this.propForm.size = false
            this.propHead = {
                action: title,
                open: true,
                row: row,
                text: text,
                component: this.componentName,
            }
        },
        closeModal() {
            this.executeCommit({
                mutation: "close_modal",
            });
            this.propHead = {
                action: "",
                open: false,
                module: "competidor",
                text: ""
            };
            this.componentName = null;
        },
        refrest() {
            this.closeModal();
            this.fetchData();
        },
        updateConfigStatus(status) {
            this.competitorConfigStatus = status;
            this.fetchData();
        },
        updateCompetitor(competitor) {
            this.selectedCompetitor = competitor;
            this.fetchData();
        },
        updatePositioning(positioning) {
            this.selectedPositioning = positioning;
            this.fetchData();
        },
    }
}
</script>
